import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";

interface Props {
    value: string | null;
    onChange: (x: string | null) => void;
}

/**Permite al usuario seleccionar manualmente el acuse de cancelación del SAT */
export class AcuseCancelacionManual extends React.PureComponent<Props> {
    onSubir = async () => {
        const data = await kea.upload();
        if(data != null) {
            const base64 = await kea.blobToBase64(data);
            this.props.onChange(base64);
        }
    }

    onQuitar = async () => {
        this.props.onChange(null);
    }

    render() {
        const tieneAcuse = !!this.props.value;
        return (
            <div className="alert alert-info">
                <label>
                    Acuse de cancelación manual
                </label>
                <p>
                    Puede subir manualmente el XML/PDF del acuse de cancelación generado por el SAT en caso
                    de que la cancelación se haya realizado por medio del portal del SAT
                </p>
                {
                    tieneAcuse ?
                        <kea.Button onClick={this.onQuitar}>
                            Quitar XML/PDF del acuse
                        </kea.Button> :
                        <kea.Button onClick={this.onSubir}>
                            Subir XML/PDF del acuse de cancelación
                        </kea.Button>
                }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/facturas/cancelacion/edit/acuse.tsx